import React from "react";

export const nlToBr = (text: string) =>
  (text || "").split("\n").map((l, index) => (
    <React.Fragment key={index}>
      {l}
      <div style={{ marginBottom: "13px" }} />
    </React.Fragment>
  ));
